import type { LessonClass as LessonClassData } from '@mathflat/domain/LessonClass'

import { DTO } from '../DTO'

export class LessonClass extends DTO {
  id: LessonClassData['id']
  name: LessonClassData['name']
  studentNameExample: string
  remainStudentCount: LessonClassData['remainStudentCount']
  teacherNameExample: string
  remainTeacherCount: LessonClassData['remainTeacherCount']

  constructor(data: LessonClassData) {
    super()
    this.id = data.id
    this.name = data.name
    this.studentNameExample = data.studentNameExample ?? ''
    this.remainStudentCount = data.remainStudentCount
    this.teacherNameExample = data.teacherNameExample ?? ''
    this.remainTeacherCount = data.remainTeacherCount
  }
}
